import type { GlobalThisWithLocalDevContext } from './GlobalThisWithLocalDevContext.tsx';

export default function getRdeDns(): string | undefined {
	// oxlint-disable-next-line typescript/consistent-type-assertions
	return (globalThis as GlobalThisWithLocalDevContext).localDevContext?.RDE_DNS;
}
